<div class="container">
    <div class="row hidden-small">
        <div class="col">
            <div class="jumbotron w-100">
                <h1>Chat</h1>
                <p>Ci sono {{ getUnreadMessages().length }} nuovi messaggi</p>
                <button type="button" class="btn btn-primary" (click)="openModal('#newChatModal')">Nuova chat</button>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="messaging">
                <div class="inbox_msg">
                    <div class="inbox_people" [ngClass]="{ 'active' : inbox_people_active }">
                        <div (click)="inbox_people_active = !inbox_people_active" class="toggle">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="20" height="43" x="0" y="0" viewBox="0 0 384 384" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                                <g>
                                    <path xmlns="http://www.w3.org/2000/svg" d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#ffffff" data-original="#000000" style="" class="" />
                                    <path xmlns="http://www.w3.org/2000/svg" d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#ffffff" data-original="#000000" style="" class="" />
                                    <path xmlns="http://www.w3.org/2000/svg" d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#ffffff" data-original="#000000" style="" class="" />
                                </g>
                            </svg>
                        </div>
                        <div class="headind_srch">
                            <div class="recent_heading">
                                <h4>Recent</h4>
                            </div>
                            <div class="srch_bar">
                                <div class="stylish-input-group">
                                    <input type="text" class="search-bar" placeholder="Search" name="filter_chat" id="filter_chat" [(ngModel)]="filter.chat">
                                    <span class="input-group-addon">
                                        <button type="button"> <i class="fa fa-search" aria-hidden="true"></i> </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="inbox_chat">
                            <a routerLink="/chat" [queryParams]="changeQueryParam({selected: chat_obj.key})" (click)="inbox_people_active = !inbox_people_active" *ngFor="let chat_obj of get(filter.chat) | keyvalue">
                                <span [hidden]="!getUnreadMessages(chat_obj.key).length" class="badge badge-danger">{{ getUnreadMessages(chat_obj.key).length }}</span>
                                <div class="chat_list" [ngClass]="{ 'active_chat' : selected==chat_obj.key }">
                                    <div class="chat_people">
                                        <div class="chat_img">
                                            <img [src]="chat_obj.value?.usherGroup?.length > 2? 'assets/img/group.svg' : getChatImage(chat_obj.value)" alt="">
                                        </div>
                                        <div class="chat_ib">

                                            <div class="row">
                                                <div class="col-8">
                                                    <h5>{{ getChatName(chat_obj.value) }}</h5>
                                                    <p>{{ getLastText(chat_obj.value) }}</p>
                                                </div>
                                                <div class="col-4 pl-0 pr-3">
                                                    <div style="display: block;overflow: hidden;" class="w-100">
                                                        <div (click)="openModal('#deleteChatModal')" class="btn btn-primary btn-sm mb-2 ml-2 float-right">
                                                            <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                            </svg>
                                                        </div>
                                                        <div class="btn btn-primary btn-sm mb-2 ml-2 float-right">
                                                            <a [href]="getLinkChat(chat_obj.key)">
                                                                <svg fill="white" width="15px" height="15px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.827 477.827" style="enable-background:new 0 0 477.827 477.827;" xml:space="preserve">
                                                                    <g>
                                                                        <g>
                                                                            <path d="M441.537,160.625c1.489-7.981,2.243-16.082,2.253-24.201C443.699,61.019,382.498-0.035,307.093,0.056
                                            c-57.402,0.069-108.63,36.034-128.194,89.999c-35.029-13.944-74.73,3.148-88.675,38.177c-1.207,3.032-2.195,6.146-2.956,9.319
                                            c-55.932,8.365-94.492,60.488-86.127,116.42c7.502,50.163,50.596,87.275,101.316,87.254h85.333
                                            c9.426,0,17.067-7.641,17.067-17.067c0-9.426-7.641-17.067-17.067-17.067h-85.333c-37.703,0-68.267-30.564-68.267-68.267
                                            s30.564-68.267,68.267-68.267c9.426,0,17.067-7.641,17.067-17.067c0.031-18.851,15.338-34.108,34.189-34.077
                                            c8.915,0.015,17.471,3.517,23.837,9.757c6.713,6.616,17.519,6.537,24.135-0.176c2.484-2.521,4.123-5.751,4.69-9.245
                                            c9.264-55.733,61.954-93.403,117.687-84.139c55.733,9.264,93.403,61.954,84.139,117.687c-0.552,3.323-1.269,6.617-2.146,9.869
                                            c-1.962,7.124,0.883,14.701,7.049,18.773c31.416,20.845,39.985,63.212,19.139,94.628c-12.617,19.015-33.9,30.468-56.72,30.522
                                            h-51.2c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h51.2
                                            c56.554-0.053,102.357-45.943,102.303-102.497C477.798,208.625,464.526,180.06,441.537,160.625z" />
                                                                        </g>
                                                                    </g>
                                                                    <g>
                                                                        <g>
                                                                            <path d="M353.07,363.292c-6.614-6.387-17.099-6.387-23.712,0l-56.235,56.201V170.558c0-9.426-7.641-17.067-17.067-17.067
                                            c-9.426,0-17.067,7.641-17.067,17.067v248.934l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                            c-6.388,6.614-6.388,17.099,0,23.713l85.333,85.333c6.656,6.673,17.463,6.687,24.136,0.03c0.01-0.01,0.02-0.02,0.031-0.03
                                            l85.333-85.333C360.038,380.644,359.85,369.84,353.07,363.292z" />
                                                                        </g>
                                                                    </g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                    <g></g>
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="chat_date">{{ getLastDate(chat_obj.value) }}</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="mesgs">
                        <div class="msg_history" id="msg_history">
                            <span *ngFor="let message of getMessages().slice().reverse(); index as i">

                                <div [ngClass]="{ 'incoming_msg' : !message.isOwner, 'outgoing_msg' : !!message.isOwner }">
                                    <div [hidden]="!selected || !!message.isOwner" class="incoming_msg_img"> <img [src]="getMedia(message.picture || 'assets/img/user-profile.svg')" alt=""> </div>
                                    <div [ngClass]="{ 'received_msg' : !message.isOwner, 'outgoing_msg' : !!message.isOwner }">
                                        <div [ngClass]="{ 'received_withd_msg' : !message.isOwner, 'sent_msg' : !!message.isOwner }">
                                          <div>
                                            <img style="max-height: 250px;"(click)="showImage(window.flowup.utils.getMedia(message.media_url))" [src]="window.flowup.utils.getMedia(message.media_url)" *ngIf="!!message.media_url && message.type.includes('image')">
                                                      <audio preload="auto" style="width: 220px;" controls *ngIf="!!message.media_url && message.type?.includes('audio')">
                                                          <source [src]="window.flowup.utils.getMedia(message.media_url)" [type]="message.type">
                                                          Your browser does not support the audio tag.
                                                      </audio>
                                            <p *ngIf="!message.media_url">{{ message.body }}</p>
                                                  </div>
                                            <span class="time_date"> {{ moment(message.creation_timestamp).fromNow() }} </span>
                                        </div>
                                    </div>
                                </div>
                            </span>
                            <span id="chat-bottom"></span>
                        </div>
                        <div [hidden]="!selected" class="type_msg">
                            <div class="input_msg_write">
                                <textarea [(ngModel)]="body" name="write_msg" id="write_msg" type="text" class="form-control write_msg" placeholder="Type a message" rows="3"></textarea>
                                <button [disabled]="disable_send_button" (click)="send()" class="msg_send_btn" type="button">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<span id="newChatModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" style="overflow-y: scroll;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Crea una nuova chat</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal('#newChatModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-2">
                        <a class="navbar-brand">Utenti</a>
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar_new_chat" aria-controls="navbar_comunicazioni" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>

                        <div class="collapse navbar-collapse flex-row justify-content-between" id="navbar_new_chat">
                            <ul class="nav nav-tabs">
                                <li class="nav nav-tabs" *ngFor="let usertype of getUsersType(); let i = index;">
                                    <a class="nav-link btn text-capitalize" [ngClass]="{'active': queryparams()['user-type'] == usertype}" [routerLink]="'/chat'" [queryParams]="changeQueryParam({'user-type': usertype})">{{ usertype }}</a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                    <div class="row">
                        <div class="col-12">
                            <input class="form-control" placeholder="Inserisci un filtro di ricerca" name="filter_new_chat" id="filter_new_chat" [(ngModel)]="filter.text" />
                        </div>
                    </div>

                    <form>
                        <div id="chat-target" class="form-check form-check-group" *ngFor="let user of getUsers(); index as i;">
                            <input (change)="onChangeUserSelector($event, i)" class="btn" id="checkbox{{i}}" name="checkbox{{i}}" type="checkbox">
                            <label class="btn" for="checkbox{{i}}">{{ user.public_configuration.nome }}</label>
                        </div>
                    </form>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-block" (click)="openChat()">Apri</button>
                    <button type="button" class="btn btn-secondary btn-block" data-dismiss="modal" (click)="closeModal('#newChatModal')">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>


<span id="firstChatModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Crea una nuova chat</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal('#firstChatModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="form-group" [hidden]="queryparams()['chat-target']?.length > 1">
                            <input [(ngModel)]="titleFirstMessage" type="text" class="form-control" id="titolo-chat" name="titolo-chat" placeholder="Titolo chat di gruppo">
                        </div>
                        <div class="form-group">
                            <textarea [(ngModel)]="bodyFirstMessage" class="form-control" id="firstChatTextarea" name="firstChatTextarea" rows="8" placeholder="Testo messaggio ..."></textarea>
                        </div>
                    </form>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-block" (click)="sendFirstMessage()">Invia</button>
                </div>
            </div>
        </div>
    </div>
</span>


<span id="deleteChatModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Elimina chat</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal('#deleteChatModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <p>
                        Sei sicuro di voler eliminare la chat?
                    </p>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-block" (click)="deleteChat()">Elimina</button>
                </div>
            </div>
        </div>
    </div>
</span>
